<template>
    <keep-alive>
        <router-view></router-view>
    </keep-alive>
</template>

<script>
import { mapActions } from 'vuex'
import titleMixin from '../../mixin/title'
export default {
    name: 'Goods',
    mixins: [titleMixin],
    title: function fc() { return this.$t('mx_mobile.App.1596628387180') }, // '商品管理'
    props: {},
    components: {},
    data() {
        return {}
    },
    computed: {},
    watch: {},
    created() {
        this.initData()
    },
    mounted() { },
    methods: {
        ...mapActions([
            'setCurrency',
            'setDomain'
        ]),
        initData() {
            this.setCurrency()
            this.setDomain()
        }
    },
    updated() { },
    beforeDestroy() { },
    beforeRouteLeave(to, from, next) {
        next()
    }
}
</script>

<style lang='less' rel='stylesheet/less' scoped>
@import "./zh-cn.less";
@import "./en.less";
</style>
